module.exports = /*#__PURE__*/JSON.parse('{"X":["JP","TH","ID","MY","TW","KR","PH","IN","VN"]}')